// extracted by css-extract-rspack-plugin
export default {"container":"_342536cb"};